/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const MemberDto = zod.object({
  "id": zod.string().uuid().optional(),
  "lastName": zod.string().optional(),
  "firstName": zod.string().optional(),
  "middleName": zod.string().optional(),
  "suffix": zod.string().optional(),
  "fieldName": zod.string().optional(),
  "birthday": zod.coerce.date().optional(),
  "genderId": zod.number().optional(),
  "genderCode": zod.string().optional(),
  "genderName": zod.string().optional(),
  "contactNumber": zod.string().optional(),
  "addressLine1": zod.string().optional(),
  "addressLine2": zod.string().optional(),
  "barangayId": zod.number().optional(),
  "barangayName": zod.string().optional(),
  "cityMunicipalityId": zod.number().optional(),
  "cityMunicipalityName": zod.string().optional(),
  "provinceId": zod.number().optional(),
  "provinceName": zod.string().optional(),
  "postalCode": zod.string().optional(),
  "memberGroupId": zod.number().optional(),
  "memberGroupCode": zod.string().optional(),
  "memberGroupName": zod.string().optional(),
  "password": zod.string().optional(),
  "userAccountId": zod.string().uuid().optional(),
  "approver1Id": zod.string().uuid().optional(),
  "approver1Name": zod.string().optional(),
  "approver2Id": zod.string().uuid().optional(),
  "approver2Name": zod.string().optional(),
  "employeeNumber": zod.string().optional(),
  "badgeNumber": zod.string().optional(),
  "dailyWorkSchedule": zod.string().optional(),
  "documentLocation": zod.string().optional(),
  "dateHired": zod.coerce.date().optional(),
  "positionId": zod.number().optional(),
  "positionName": zod.string().optional(),
  "memberStatusId": zod.number().optional(),
  "memberStatusCode": zod.string().optional(),
  "memberStatusName": zod.string().optional(),
  "memberClassificationId": zod.number().optional(),
  "memberClassificationName": zod.string().optional(),
  "employmentStatusId": zod.number().optional(),
  "employmentStatusName": zod.string().optional(),
  "areaCode": zod.string().optional(),
  "areaOfAssignmentBranchId": zod.number().optional(),
  "areaOfAssignmentBranchName": zod.string().optional(),
  "areaId": zod.number().optional(),
  "areaName": zod.string().optional(),
  "clientId": zod.number().optional(),
  "clientName": zod.string().optional(),
  "retailGroupId": zod.number().optional(),
  "retailGroupName": zod.string().optional(),
  "storeCode": zod.string().optional(),
  "regionId": zod.number().optional(),
  "regionName": zod.string().optional(),
  "costCenterId": zod.number().optional(),
  "costCenterName": zod.string().optional(),
  "businessUnitId": zod.number().optional(),
  "businessUnitName": zod.string().optional(),
  "tenure": zod.number().optional(),
  "contractStartDate": zod.coerce.date().optional(),
  "contractEndDate": zod.coerce.date().optional(),
  "leaveStartDate": zod.coerce.date().optional(),
  "leaveEndDate": zod.coerce.date().optional(),
  "estimatedDateOfDelivery": zod.coerce.date().optional(),
  "dateResigned": zod.coerce.date().optional(),
  "lastWorkingDate": zod.coerce.date().optional(),
  "payModeId": zod.number().optional(),
  "payModeName": zod.string().optional(),
  "payTypeId": zod.number().optional(),
  "payTypeName": zod.string().optional(),
  "paycardTypeId": zod.number().optional(),
  "paycardTypeName": zod.string().optional(),
  "paycardNumber": zod.string().optional(),
  "paycardStatusId": zod.number().optional(),
  "paycardStatusName": zod.string().optional(),
  "periodTypeId": zod.number().optional(),
  "periodTypeName": zod.string().optional(),
  "ratePHP": zod.number().optional(),
  "mealAllowancesEvery15thAnd30th": zod.number().optional(),
  "loadEvery15thAnd30th": zod.number().optional(),
  "transportationAllowance": zod.number().optional(),
  "safetyAllowanceEvery15thAnd30th": zod.number().optional(),
  "housingAllowanceEvery15thAnd30th": zod.number().optional(),
  "relocationAllowance": zod.number().optional(),
  "mandatoryDeductionId": zod.number().optional(),
  "mandatoryDeductionName": zod.string().optional(),
  "hmoName": zod.string().optional(),
  "hmoNumber": zod.string().optional(),
  "remarks": zod.string().optional(),
  "createdBy": zod.string().optional(),
  "createdDate": zod.coerce.date().optional(),
  "updatedBy": zod.string().optional(),
  "updatedDate": zod.coerce.date().optional()
});

export type MemberDto = zod.input<typeof MemberDto>;
export type MemberDtoOutput = zod.output<typeof MemberDto>;
